import { render, staticRenderFns } from "./BusinessItem.vue?vue&type=template&id=135c2f6a&scoped=true&"
import script from "./BusinessItem.vue?vue&type=script&lang=ts&"
export * from "./BusinessItem.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessItem.vue?vue&type=style&index=0&id=135c2f6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c2f6a",
  null
  
)

export default component.exports